const LOGIN_PATH_KEY = 'login_path';
const USER_LOGIN_KEY = 'user_login';

export const setLoginPath = (url) => {
  window.sessionStorage.setItem(LOGIN_PATH_KEY, url);
};

export const getLoginPath = () => {
  let loginPath = window.sessionStorage.getItem(LOGIN_PATH_KEY);
  if (!loginPath) {
    // At a minimum if we don't know where to redirect to just go to "/" login page route.
    loginPath = '/';
  }
  return loginPath;
};

export const setUserLogin = (login) => {
  window.sessionStorage.setItem(USER_LOGIN_KEY, login);
};

export const getUserLogin = () => {
  const userLogin = window.sessionStorage.getItem(USER_LOGIN_KEY);
  return userLogin ? userLogin : '';
};
